<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les laboratoires" />
            <Leslaboratoires />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import Leslaboratoires from './Leslaboratoires.vue';

export default {
    name: 'PelerinagePage',
    components: {
        NavBar,
        PageTitle,
        Leslaboratoires,
        FooterComp,
    }
}
</script>